import { useState, useEffect } from 'react'
import { Dialog, DialogContent, DialogFooter } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { User } from '@/interfaces/user'
import { UserSearchInput } from '@/components/UserSearchInput'

interface InviteUserDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onInvite: (user: User) => void
  isInviting: boolean
}

export const InviteUserDialog = ({
  open,
  onOpenChange,
  onInvite,
  isInviting,
}: InviteUserDialogProps) => {
  const [selectedUser, setSelectedUser] = useState<User | null>(null)

  // Reset state when dialog closes
  useEffect(() => {
    if (!open) {
      setSelectedUser(null)
    }
  }, [open])

  const handleInvite = () => {
    if (selectedUser) {
      onInvite(selectedUser)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent
        className="w-[calc(100%-2rem)] sm:max-w-2xl max-h-[90vh] overflow-visible bg-[#FF9DBE] p-0 border-0"
        showCloseButton={false}
      >
        <div className="bg-[#FF9DBE] relative w-full rounded-lg overflow-visible">
          {/* Title */}
          <div className="pt-10 pb-6 text-center">
            <h2 className="font-momo-trust-display text-[42px] font-bold text-black">
              Bạn muốn mời ai
              <br />
              viết cho mình?
            </h2>
          </div>

          {/* White Content Area */}
          <div className="rounded-t-3xl px-8 pt-8 pb-6 mx-6 mb-0">
            <UserSearchInput
              selectedUser={selectedUser}
              onSelectUser={setSelectedUser}
              onClearUser={() => setSelectedUser(null)}
              disabled={isInviting}
              placeholder="Tìm kiếm..."
            />
          </div>

          {/* Action Buttons */}
          <DialogFooter className="sm:justify-center flex-row items-center justify-center gap-4 px-6 pt-6 pb-20">
            <Button
              size={null}
              className="btn-primary-wide hover:bg-primary/90 w-fit"
              disabled={isInviting || !selectedUser}
              onClick={handleInvite}
            >
              {isInviting ? 'Đang gửi...' : 'Mời'}
            </Button>
          </DialogFooter>
        </div>
      </DialogContent>
    </Dialog>
  )
}
